<template>
  <div>
    
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
            <img :src="img" width="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
   
   

   <Row style="width: 100%;margin-top: 50px;">
      <Col span="24">
            
            <span style="font-size: 28px;">{{info.articleTitle}}</span></br></br>
            <span style="font-size: 18px;margin-left:80px">{{info.description}}【<font color="blue">如继续浏览该资讯，请扫码支付，2元/篇。</font>】</span></br>
      </Col>
    </Row>
    

     <Row style="display: flex;justify-content: center;margin-top:50px">
      <Col span="24" style="    min-height: 200px;
                                border-bottom: #3339 solid 1px;
                                font-size: 18px;text-align:left;text-indent:2em;
                                line-height: 32px;width:1560px;">
            <p style="font-size: 18px;text-align:right;">{{info.createBy}}{{info.createTime}}</p></br>
            
            <!-- 内容区域：带二维码遮罩 -->
            <div class="content-wrapper">
              <!-- 二维码遮罩层 -->
              <div v-if="!hasScanned" class="qr-mask">
                <div class="qr-content">
                  <img :src="qrCodeImg" alt="扫码查看内容" class="qr-code"/>
                  <p class="qr-tip">请使用微信扫描二维码查看完整内容</p>
                  <p class="qr-sub-tip">扫码后即可免费阅读</p>
                  <!-- 模拟扫码按钮（实际项目中可删除，仅用于测试） 
                  <button class="simulate-btn" @click="simulateScan">模拟已扫码</button>-->
                </div>
              </div>
              <!-- 文章内容 -->
              <p :class="{'blurred': !hasScanned}">{{info.content}}</p>
            </div>
            </br></br></br>
      </Col>
    </Row>
    
</br>
    <Row style="width: 85%;margin-top: 10px;margin-left: 170px;">
      <Col span="24">
           <div class="turnList" style="text-align:right;letter-spacing: 2px;">
                <!--<a href="/newsData"><span style="color: #5645f7;font-size:20px;text-align:left;letter-spacing: 2px;">|返回列表|</span></a><br/><br/>-->
                <router-link  style="color: #616060;font-size:20px;text-align:right;letter-spacing: 2px;"
                                  :to="{path:'/newsData'}">
                      【返回列表】</router-link>
                <!--<span @click="getLastM()">上一篇：{{lastNewsInfo.title}}</span><br/>
                <span @click="getNextM()">下一篇：{{nextNewsInfo.title}}</span><br/><br/><br/>-->
            </div>
      </Col>
    </Row>
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      "id":"",
      "title":"",
      "shortTitle":"",
      "attrTxt":"",
      "views":"",
      "author":"",
      "releaseTime":"", 
      info:{
      },
      isOk:false,
      // info1:{},
      nextNewsInfo:{},
      lastNewsInfo:{},
      hasScanned: false, // 是否已扫码
      qrCodeImg: "../../../../static/ewm.jpg", // 二维码图片路径，请替换为实际路径
      carouselImg:[
        {src: "../../../../static/15.jpg",href: "www.baidu.com"},
        {src: "../../../../static/220.jpg",href: "www.baidu.com"},
        {src: "../../../../static/221.jpg",href: "www.baidu.com"},
        {src: "../../../../static/22.jpg",href: "www.baidu.com"}
      ],
      img: "../../../../static/officeImg/mediaInformation/banner.png",
      img2:"../../../../static/officeImg/index/areaGas.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
     
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    this.checkScanStatus(); // 检查是否已扫码
  },
  created(){
    // console.log(this.$route.query.info);
    this.info = this.$route.query.info;
    this.getNewsDetail(this.info.articleId);
    },
  methods: {
    loadData: function() {
    },
    // 检查扫码状态（从 localStorage 或接口获取）
    checkScanStatus() {
      // 方式1：从 localStorage 读取
      const scanned = localStorage.getItem('article_' + this.info.articleId + '_scanned');
      if (scanned === 'true') {
        this.hasScanned = true;
      }
      
      // 方式2：从接口验证（推荐）
      // this.verifyScanStatus();
    },
    // 模拟扫码成功（实际项目中删除此方法）
    simulateScan() {
      this.hasScanned = true;
      localStorage.setItem('article_' + this.info.articleId + '_scanned', 'true');
      this.$Message.success('扫码成功，现在可以阅读完整内容了！');
    },
    // 实际项目中：轮询或 WebSocket 检查扫码状态
    verifyScanStatus() {
      // 调用后端接口检查用户是否已扫码
      // http.get('/api/checkScanStatus?articleId=' + this.info.articleId).then(res => {
      //   if (res.data.hasScanned) {
      //     this.hasScanned = true;
      //     localStorage.setItem('article_' + this.info.articleId + '_scanned', 'true');
      //   }
      // });
    },
    getNewsDetail(articleId) {
      const config = {
        url: protocol.param_NewsDetail.url + "/" + articleId
      }
      http.get(config).then((res) => {
        const { code, data, total } = res.data;
        if (code === 0 && data && Array.isArray(data)) {
        
        }
      }).catch(err => {
        console.error(`获取数据失败:`, err);
      });
    },
    getLastM(){
      if(this.nextNewsInfo.title == "没有上一篇啦"){
        return;
      }
      this.info = this.lastNewsInfo;
      
      this.lastNews();
      this.nextNews();

    },

    getNextM(){
     console.log(this.nextNewsInfo);
      
      if(this.nextNewsInfo.title == "没有下一篇啦"){
        return;
      }
      this.info = this.nextNewsInfo;
      this.nextNews();
      this.lastNews();
     

    },
   
    lastNews(){
        var id = this.info.id;
        var channelId = this.info.channelId;
        protocol.param_lastNews.data={
          id : id,
          channelId : channelId
        }
        http.post(protocol.param_lastNews).then(res =>{
          let{code,msg,lastNews}=res.data;
            this.lastNewsInfo=lastNews;
          if(this.lastNewsInfo == null){
            this.lastNewsInfo = {title:"没有上一篇啦"};
          }
         
         
        });
    },
    nextNews(){
        var id = this.info.id;
        var channelId = this.info.channelId;
        protocol.param_nextNews.data={
          id : id,
          channelId : channelId
        }
        http.post(protocol.param_nextNews).then(res =>{
          let{code,msg,nextNews}=res.data;
            this.nextNewsInfo=nextNews;
            if(this.nextNewsInfo == null){
            this.nextNewsInfo = {title:"没有下一篇啦"};
          }
          
         
         
        });
    },
    viewAdd(){
      
        var id = this.info.id;
        var title = this.info.title;
       
        protocol.param_addViews.data={
          id : id
        }
        http.get(protocol.param_addViews).then(res =>{
        });
      }
     

    
    

  }
};
</script>
<style scoped>
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.imgCss{
  line-height: 50px; font-size: 20px; background: rgb(86, 69, 247) none repeat scroll 0% 0%; margin: 0px; color: white;height: 50px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}

/* 二维码遮罩样式 */
.content-wrapper {
  position: relative;
  min-height: 300px;
}

.qr-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  backdrop-filter: blur(2px);
}

.qr-content {
  text-align: center;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.qr-code {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  border: 1px solid #eee;
}

.qr-tip {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.qr-sub-tip {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

.simulate-btn {
  padding: 8px 20px;
  background: #5645f7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.simulate-btn:hover {
  background: #4534e6;
}

/* 未扫码时内容模糊 */
.blurred {
  filter: blur(5px);
  user-select: none;
  pointer-events: none;
  max-height: 200px;
  overflow: hidden;
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// src/views/newsDataDetails/newsDataDetails.vue